import { render, staticRenderFns } from "./CategoryField.vue?vue&type=template&id=10739ee6"
import script from "./CategoryField.vue?vue&type=script&lang=js"
export * from "./CategoryField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports